import styled from '@emotion/styled';

const Header = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  border-bottom: 1px solid #00000019;

  h2 {
    font-size: 18px;
    font-weight: 500;
    
    span {
      opacity: 0.3;
    }
  }
`;

export default Header;
